import { render, staticRenderFns } from "./AddTeamUserModal.vue?vue&type=template&id=06b13198&lang=pug"
import script from "./AddTeamUserModal.vue?vue&type=script&lang=js"
export * from "./AddTeamUserModal.vue?vue&type=script&lang=js"
import style0 from "./AddTeamUserModal.vue?vue&type=style&index=0&id=06b13198&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports